import { createContext, useContext, useMemo } from "react";

// Source of truth (events/communities/matches) still lives in useAppLogic,
// which owns the Firestore subscriptions. This context makes those lists
// available to any component without threading them through intermediaries
// that don't use them themselves (e.g. Events.jsx used to receive
// communitiesList/eventsList only to forward them to AttendeeProfile).
//
// It also centralizes the "is this actually an array?" defensive check in
// one place instead of recomputing safeEvents/safeCommunities/safeMatches
// wherever the raw lists are consumed.
const DataContext = createContext(null);

export function DataProvider({ events, communities, matches, children }) {
  const value = useMemo(
    () => ({
      events: Array.isArray(events) ? events : [],
      communities: Array.isArray(communities) ? communities : [],
      matches: Array.isArray(matches) ? matches : [],
    }),
    [events, communities, matches]
  );

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
}

export function useAppData() {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error("useAppData must be used within a DataProvider");
  }
  return context;
}
